import { Spacer } from "@chakra-ui/react";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { RanaHeading } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { BackButton } from "@/components/back-button";

import { ProjectContext } from "../../../stores/project-provider";

export function ProjectHeader() {
  const { tenant } = useContext(TenantContext);

  const project = useContext(ProjectContext);
  return (
    <>
      <BackButton to={`/${tenant}/projects`}>
        <FormattedMessage id="backbutton.back_to_projects" defaultMessage="Back to projects" />
      </BackButton>
      <RanaHeading type="h1" addDot>
        {project.name}
      </RanaHeading>
      <Spacer />
      {/* FUTURE */}
      {/* <ButtonWrapper flexWrap={{ base: "wrap", md: "nowrap" }}>
        <Button isDisabled variant="secondary" leftIcon={<StarIcon boxSize="4" />}>
          <FormattedMessage id="button.favorite" defaultMessage="Favorite" />
        </Button>
        <Button isDisabled variant="secondary" leftIcon={<ExternalLinkIcon boxSize="4" />}>
          <FormattedMessage
            id="button.open_in_desktop_client"
            defaultMessage="Open in Desktop Client"
          />
        </Button>
        <Button isDisabled variant="secondary" leftIcon={<ExternalLinkIcon boxSize="4" />}>
          <FormattedMessage id="button.open_in_shell" defaultMessage="Open in shell" />
        </Button>
      </ButtonWrapper> */}
    </>
  );
}
